import React, { memo } from 'react';
import './EventCard.css';
import CalendarDayIcon from './calendar/CalendarDayIcon';

const EventCard = memo(({ 
  event, 
  formatDateTime, 
  onClick
}) => {
  const handleClick = () => onClick?.(event);

  const start = event.startDatetime || event.eventDate;
  const dateText = formatDateTime ? formatDateTime(start) : (start || '');

  const eventTitle = event.name || event.title || 'Untitled Event';
  const courseName = event.endeavorName || event.courseName || event.endeavor?.name || '';
  const isCanceled = Boolean(event.canceled);
  const seq = typeof event.sequence === 'number' ? event.sequence : null;
  const fromSyllabus = Boolean(event.isFromSyllabus);

  return (
    <div 
      className="assignment-item event-as-assignment"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      title={eventTitle}
    >
      <div className="assignment-content">
        {/* Row 1: date icon + event title */}
        <div className="event-inline-row">
          <span className="event-inline-icon">
            <CalendarDayIcon
              date={start || new Date()}
              size={26}
              className="calendar-inline-icon"
            />
          </span>
          <h4 className="event-inline-title single-line">
            {eventTitle}
          </h4>
        </div>

        {/* Row 2: date (left) + course name (right) */}
        <div className="event-second-row">
          <span className="event-date-left">
            {isCanceled ? '❌ Canceled' : (dateText || 'No date')}
          </span>
          <span className="event-course-right" title={courseName}>
            {seq != null && <>Session #{seq} · </>}
            {fromSyllabus && <>🤖 </>}
            {courseName}
          </span>
        </div>
      </div>
    </div>
  );
});

EventCard.displayName = 'EventCard';

export default EventCard;
